import React, { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from 'react-router-dom';
import Spining from "../../UI/Spining/Spining";
import Title from "../../UI/Text/Title";

import WtPrev from "./WtPrev";
import WtPrev2 from "./WtPrev2";
import WtPrev3 from "./WtPrev3";
import WtPrev4 from "./WtPrev4";
import WtPrev5 from "./WtPrev5";
import WtPrev6 from "./WtPrev6";
import WtPrev7 from "./WtPrev7";
import WtPrev8 from "./WtPrev8";
import WtPrev9 from "./WtPrev9";
import WtPrev10 from "./WtPrev10";
import "./WtPrev.css";
import "./WtPrev2.css";
import "./WtPrev3.css";
import "./WtPrev4.css";
import "./WtPrev5.css";
import "./WtPrev6.css";
import "./WtPrev7.css";
import "./WtPrev8.css";
import "./WtPrev9.css";
import "./WtPrev10.css";
import styles from "./WhatsappWidget.module.css";
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import { WHATSAPP_WIDGET_REPORT } from "../../UI/Table/ColumnConst";
import Axios from "axios";
import Dialog from "react-dialog";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FiUser, FiLayout, FiSettings, FiSliders, FiGlobe, FiBarChart2, FiCpu, FiCheck } from "react-icons/fi";
import WhatsappLogo from "../assets/img/WhatsappLogo-Photoroom.png";

const WhatsappWidget = ({ setGeneratedScript }) => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  // const mobileNumber = lStorage?.user?.mobile || "";
  const currentUrl = window.location.hostname;
  const logo = lStorage.user.logo;
  const { id } = useParams();
  const history = useHistory();

  const [selectedTemplate, setSelectedTemplate] = useState('template1');
  const handleTemplateChange = (e) => {
    setSelectedTemplate(e.target.value);
  };

  const errorDivRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({
    successMessage: false,
    errorMessage: "",
    bgColor: "",
  });

  const [whatsappno, setWhatsappno] = useState("");
  const [widgetName, setWidgetName] = useState("")
  const [displayname, setDisplayname] = useState("Authkey");
  const [logoFile, setLogoFile] = useState(null);

  const DEFAULT_LOGO_URL = "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202408/66ab6e282f789.png";

  const [logoUrl, setLogoUrl] = useState(DEFAULT_LOGO_URL);
  const [wtbgcolor, setWtbgcolor] = useState("#008069");
  const [welcomeText, setWelcomeText] = useState(
    "Hi there 👋, How can I help you?"
  );
  const [preFilledMsg, setPreFilledMsg] = useState("hi");
  const [preFilledTemplate2, setPreFilledTemplate2] = useState("");
  const [preFilledTemplate3, setPreFilledTemplate3] = useState("");
  const [preFilledTemplate4, setPreFilledTemplate4] = useState("");
  const [preFilledTemplate5, setPreFilledTemplate5] = useState("");
  const [preFilledTemplate6, setPreFilledTemplate6] = useState("");
  const [preFilledTemplate7, setPreFilledTemplate7] = useState("");
  const [preFilledTemplate8, setPreFilledTemplate8] = useState("");
  const [preFilledTemplate9, setPreFilledTemplate9] = useState("");
  const [preFilledTemplate10, setPreFilledTemplate10] = useState("hi");
  const [widgetStatus, setWidgetStatus] = useState("no");
  const [position, setPosition] = useState("right");
  const [sideMargin, setSideMargin] = useState("20");
  const [marginBottom, setMarginBottom] = useState("20");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [responsedata, setResponseData] = useState();
  const [copystatus, setCopyStatus] = useState(false);
  const [disable, setDisable] = useState(false);
  const [widgetCreated, setWidgetCreated] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openSections, setOpenSections] = useState({ step_template: false, step_settings: false });
  const toggleSection = (key) => setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));

  const [showAddons, setShowAddons] = useState(false);
  const [addonPlans, setAddonPlans] = useState([]);
  const [activeAddonNames, setActiveAddonNames] = useState(new Set());

  const countryCurrency = lStorage?.user?.country_currency || "USD";
  const CURRENCY_CONFIG = {
    INR: { symbol: "₹", key: "amount_inr" },
    USD: { symbol: "$", key: "amount_usd" },
    EUR: { symbol: "€", key: "amount_eur" },
  };
  const currency = CURRENCY_CONFIG[countryCurrency] || CURRENCY_CONFIG.USD;

  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
  const [showFinalConfirm, setShowFinalConfirm] = useState(false);
  const [selectedAddonPlan, setSelectedAddonPlan] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [autoRenew, setAutoRenew] = useState(false);

  const [isSignedUp, setIsSignedUp] = useState(false);
  const [showSignupPrompt, setShowSignupPrompt] = useState(false);


  useEffect(() => {
    if (currentUrl === "console.authkey.io") {
      setDisplayname("Authkey");
      setLogoUrl(
        "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202408/66ab6e282f789.png"
      );
    } else {
      setDisplayname(currentUrl);
      setLogoUrl(WhatsappLogo);
    }
  }, []);

  const hasRemoveBranding = activeAddonNames.has("Remove Branding");

  useEffect(() => {
    fetchWhatsAppWidget();
    fetchWhatsAppWidgetID();
    fetchWhatsappNumber();
    fetchAddonPlans();
    fetchUserActivePlans();
  }, []);

  const fetchUserActivePlans = async () => {
    try {
      const response = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        method: "fetchUserEnabledPlans",
        user_id: userId,
        token: userToken,
      });
      if (response.data.success === true) {
        const names = new Set();
        (response.data.data || []).forEach((plan) => {
          if (plan.add_on && typeof plan.add_on === "object") {
            Object.keys(plan.add_on).forEach((addonName) => names.add(addonName));
          }
        });
        setActiveAddonNames(names);
      }
    } catch (error) {
      console.error("Error fetching user plans:", error);
    }
  };

  const fetchAddonPlans = async () => {
    try {
      const response = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        method: "fetchPlans",
        user_id: userId,
        token: userToken,
      });
      if (response.data.success === true) {
        const ALLOWED_PLANS = ["Remove Branding", "Widget Analytics"];
        const filtered = (response.data.data || []).filter(
          (p) => p.status === 1 && ALLOWED_PLANS.includes(p.plan_title)
        );
        setAddonPlans(filtered);
      }
    } catch (error) {
      console.error("Error fetching addon plans:", error);
    }
  };

  const createWidget = () => {
    setWidgetCreated(true);
  };
  const handleLogoChange = (e) => {

    const file = e.target.files[0];

    const fileName = e.target.name;

    if (file) {

      setLogoFile(file);


      const img = new Image();  // Create an image object
      const reader = new FileReader();  // Create a FileReader to read the file

      // On file load, set the source of the image
      reader.onload = (e) => {
        img.src = e.target.result;  // Set the image source to the file data URL
      };
      reader.readAsDataURL(file);  // Read the file as data URL (base64 encoded)

      // When the image is loaded, you can display the preview
      img.onload = () => {

        setLogoUrl(img.src);  // Set the dashboard logo preview

      };
    }
  }
  const fetchWhatsappNumber = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(`${HOST_URL}/wp_profile.php`,
        {
          user_id: userId,
          token: userToken,
          method: "retrieve",
        }
      );
      if (response.data.success === true && response.data.data?.length > 0) {
        // console.log("Fetched widget data:", response.data.data);
        setWhatsappno(response.data.data[0].brand_number || "");
      } else {
        console.warn("Fetch failed:", response.data.message);
      }
    }
    catch (error) {
      console.error("Error fetching WhatsApp number:", error);
    }
    setLoading(false);
  }

  const fetchWhatsAppWidget = async () => {
    setLoading(true);

    try {
      const response = await Axios.post(
        `${NODE_HOST_URL}/whatsapp_widget`,
        {
          user_id: userId,
          token: userToken,
          method: "retrieve_wp_widget",
        }
      );

      if (response.data.success === true) {
        // console.log("Fetched widget data:", response.data.data);
        setWidgetData(response.data.data);
      } else {
        console.warn("Fetch failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching WhatsApp widget:", error);
    }
    setLoading(false);
  };

  const fetchWhatsAppWidgetID = async () => {
    setLoading(true);

    try {
      const response = await Axios.post(
        `https://napi.authkey.io/api/whatsapp_widget`,
        {
          user_id: userId,
          token: userToken,
          id: id,
          method: "retrieve_wp_widget_dtl",
        }
      );

      if (response.data.success === true) {
        // console.log("Fetched widget data:", response.data.data);
        const widgetData = response.data.data;
        setWidgetData(widgetData);
        setWhatsappno(widgetData.mobile_no || "");
        setDisplayname(widgetData.display_name || "");
        setLogoUrl(widgetData.image_url || DEFAULT_LOGO_URL);
        setWelcomeText(widgetData.welcome_text || "");
        setWtbgcolor(widgetData.back_color || "#FFFFFF");
        setWidgetStatus(widgetData.default_open === 1 ? "yes" : "no");
        setPosition(widgetData.wig_position || "right");
        setSideMargin(widgetData.side_align || "20");
        setMarginBottom(widgetData.bottom_align || "20");
        setPreFilledMsg(widgetData.pre_filled_message || "hi");
        setPreFilledTemplate2(widgetData.pre_filled_Template2 || "");
        setPreFilledTemplate3(widgetData.pre_filled_Template3 || "");
        setPreFilledTemplate4(widgetData.pre_filled_Template4 || "");
        setPreFilledTemplate5(widgetData.pre_filled_Template5 || "");
        setPreFilledTemplate6(widgetData.pre_filled_Template6 || "");
        setPreFilledTemplate7(widgetData.pre_filled_Template7 || "");
        setPreFilledTemplate8(widgetData.pre_filled_Template8 || "");
        setPreFilledTemplate9(widgetData.pre_filled_Template9 || "");
        setPreFilledTemplate10(widgetData.pre_filled_Template10 || "");
      } else {
        console.warn("Fetch failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching WhatsApp widget:", error);
    }
    setLoading(false);

  }


  // const handleForm = async (e) => {
  //   e.preventDefault();



  //   // WhatsApp number validation
  //   if (whatsappno === "") {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please enter your WhatsApp number",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   } else if (whatsappno.length < 10) { // You can adjust this based on your format
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "WhatsApp number seems invalid. Please enter a valid number",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   }

  //   if (displayname === "") {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please enter the display name",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   }

  //   if (welcomeText === "") {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please enter the welcome text",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   }

  //   if (widgetName === "") {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please enter the widget name",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   }


  //   if (displayname === "") {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please enter the display name",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   }

  //   if (welcomeText === "") {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please enter the welcome text",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   }

  //   if (widgetName === "") {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please enter the widget name",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });
  //     return;
  //   }



  //   if (!logoFile) {
  //     setAlert({
  //       successMessage: true,
  //       errorMessage: "Please upload a logo.",
  //       bgColor: "alert alert-danger alert-dismissible",
  //     });

  //     return;
  //   }

  //   let logourl = ""
  //   if (logoFile) {
  //     const logodata = new FormData();
  //     logodata.append("amdfile", logoFile);
  //     logodata.append("doc_name", "image");
  //     logodata.append("doc_type", logoFile.type);
  //     logodata.append("user_id", userId);
  //     logodata.append("token", userToken);
  //     logodata.append("method", "create");
  //     const logores = await Axios.post(
  //       `${HOST_URL}/uploadFileWhatsapp.php`,
  //       logodata
  //     );

  //     if (logores.data.success === true) {
  //       logourl = logores.data.url;
  //       // handleUserLog("", "whatsapp_widget", "create_whatsapp_widget", logores.data.message, "whatsapp_widget", "", logodata);
  //     } else {

  //       setAlert({
  //         successMessage: true,
  //         errorMessage: logores.data.message,
  //         bgColor: "alert alert-success alert-dismissible",
  //       });
  //       //  handleUserLog("", "whatsapp_widget", "create_whatsapp_widget", logores.data.message, "whatsapp_widget", "", logodata);
  //     }
  //   }

  //   let data = {
  //     user_id: userId,
  //     method: "create_wig",
  //     mobile_no: whatsappno,
  //     wig_name: widgetName,
  //     welcome_text: welcomeText,
  //     image_url: logourl,
  //     wig_position: position,
  //     back_color: wtbgcolor,
  //     bottom_align: marginBottom,
  //     side_align: sideMargin,
  //     default_open: widgetStatus === "yes" ? 1 : 0,
  //     display_name: displayname,
  //     pre_filled_message: preFilledMsg,
  //     pre_filled_Template2: preFilledTemplate2,
  //     pre_filled_Template3: preFilledTemplate3,
  //     pre_filled_Template4: preFilledTemplate4,
  //     pre_filled_Template5: preFilledTemplate5,
  //     pre_filled_Template6: preFilledTemplate6,
  //     pre_filled_Template7: preFilledTemplate7,
  //     pre_filled_Template8: preFilledTemplate8,
  //     pre_filled_Template9: preFilledTemplate9,
  //     pre_filled_Template10: preFilledTemplate10,
  //     temp_type: selectedTemplate,


  //   };

  //   setIsLoading(true);
  //   try {
  //     const res = await Axios.post(`${NODE_HOST_URL}/whatsapp_widget`, data);
  //     setDisable(true)
  //     if (res.data.success === true) {
  //       setAlert({
  //         successMessage: true,
  //         errorMessage: res.data.message,
  //         bgColor: "alert alert-success alert-dismissible",
  //       });
  //       const scriptdata = `<script src="https://${currentUrl}/js/main.js" id="authkey-chat-widget" widget-id="${res.data.data}" defer></script>`;
  //       setResponseData(scriptdata);
  //       setGeneratedScript(scriptdata);  // send it to parent

  //       setDialogOpen(true);
  //       setDisable(false)
  //     } else {
  //       setAlert({
  //         successMessage: true,
  //         errorMessage: res.data.message,
  //         bgColor: "alert alert-danger alert-dismissible",
  //       });
  //       setDisable(false)
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   setIsLoading(false);
  // };

  const handleForm = async (e) => {
    e.preventDefault();



    // WhatsApp number validation
    if (whatsappno === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please enter your WhatsApp number",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    } else if (whatsappno.length < 10) { // You can adjust this based on your format
      setAlert({
        successMessage: true,
        errorMessage: "WhatsApp number seems invalid. Please enter a valid number",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    if (displayname === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please enter the display name",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    if (welcomeText === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please enter the welcome text",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    if (widgetName === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please enter the widget name",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }


    if (displayname === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please enter the display name",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    if (welcomeText === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please enter the welcome text",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    if (widgetName === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please enter the widget name",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }



    if (!logoFile) {
      setAlert({
        successMessage: true,
        errorMessage: "Please upload a logo.",
        bgColor: "alert alert-danger alert-dismissible",
      });

      return;
    }

    let logourl = ""
    if (logoFile) {
      const logodata = new FormData();
      logodata.append("amdfile", logoFile);
      logodata.append("doc_name", "image");
      logodata.append("doc_type", logoFile.type);
      logodata.append("user_id", userId);
      logodata.append("token", userToken);
      logodata.append("method", "create");
      const logores = await Axios.post(
        `${HOST_URL}/uploadFileWhatsapp.php`,
        logodata
      );

      if (logores.data.success === true) {
        logourl = logores.data.url;
      } else {

        setAlert({
          successMessage: true,
          errorMessage: logores.data.message,
          bgColor: "alert alert-success alert-dismissible",
        });
      }
    }

    let data = {
      user_id: userId,
      method: "create_wig",
      mobile_no: whatsappno,
      wig_name: widgetName,
      welcome_text: welcomeText,
      image_url: logourl,
      wig_position: position,
      back_color: wtbgcolor,
      bottom_align: marginBottom,
      side_align: sideMargin,
      default_open: widgetStatus === "yes" ? 1 : 0,
      display_name: displayname,
      pre_filled_message: preFilledMsg,
      pre_filled_Template2: preFilledTemplate2,
      pre_filled_Template3: preFilledTemplate3,
      pre_filled_Template4: preFilledTemplate4,
      pre_filled_Template5: preFilledTemplate5,
      pre_filled_Template6: preFilledTemplate6,
      pre_filled_Template7: preFilledTemplate7,
      pre_filled_Template8: preFilledTemplate8,
      pre_filled_Template9: preFilledTemplate9,
      pre_filled_Template10: preFilledTemplate10,
      temp_type: { template1: "Chat Button", template2: "Text Message", template3: "Dark Theme", template4: "Custom Profile", template5: "Shopping", template6: "Chat Bubble", template7: "Custom Bubble", template8: "Hospital", template9: "Support", template10: "Pill Button" }[selectedTemplate] || selectedTemplate,


    };

    setIsLoading(true);
    try {
      const res = await Axios.post(`${NODE_HOST_URL}/whatsapp_widget`, data);
      setDisable(true)
      if (res.data.success === true) {
        setAlert({
          successMessage: true,
          errorMessage: res.data.message,
          bgColor: "alert alert-success alert-dismissible",
        });
        const scriptdata = `<script src="https://${currentUrl}/js/main.js" id="authkey-chat-widget" widget-id="${res.data.data}" defer></script>`;
        setResponseData(scriptdata);
        setGeneratedScript(scriptdata);  // send it to parent

        setDialogOpen(true);
        setDisable(false)
      } else {
        setAlert({
          successMessage: true,
          errorMessage: res.data.message,
          bgColor: "alert alert-danger alert-dismissible",
        });
        setDisable(false)
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };
  
  useEffect(() => {
    if (alert.errorMessage && errorDivRef.current) {
      // Add a tiny delay to ensure DOM is updated
      setTimeout(() => {
        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }, [alert.errorMessage]);



  const handlePayment = async () => {
    setPaymentLoading(true);
    try {
      const res = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        user_id: userId,
        token: userToken,
        method: "widgetPlan",
        planId: selectedAddonPlan.id,
        payment_method: "wallet",
        amount: parseFloat(selectedAddonPlan[currency.key]),
        duration: selectedAddonPlan.plan_duration,
        auto_renew: autoRenew ? 1 : 0,
      });
      if (res.data.success === true) {
        setShowFinalConfirm(false);
        setAlert({
          successMessage: true,
          errorMessage: res.data.message || "Payment successful!",
          bgColor: "alert alert-success alert-dismissible",
        });
      } else {
        setShowFinalConfirm(false);
        setAlert({
          successMessage: true,
          errorMessage: res.data.message || "Payment failed. Please try again.",
          bgColor: "alert alert-danger alert-dismissible",
        });
      }
    } catch (error) {
      console.error("Payment error:", error);
      setShowFinalConfirm(false);
      const msg = error?.response?.data?.message || "Something went wrong. Please try again.";
      const isSuccess = error?.response?.data?.success === true;
      setAlert({
        successMessage: true,
        errorMessage: msg,
        bgColor: isSuccess ? "alert alert-success alert-dismissible" : "alert alert-danger alert-dismissible",
      });
    }
    setPaymentLoading(false);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(responsedata);
      setCopyStatus(true);
      setTimeout(() => setCopyStatus(false), 2000);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };

  const renderPreview = () => {
    const commonProps = {
      mobile_no: whatsappno,
      wig_name: widgetName,
      displayname,
      logourl: logoUrl,
      bgcolor: wtbgcolor,
      wltxt: welcomeText,
      wtstatus: "yes",
      position,
      sidemargin: sideMargin,
      marginbottom: marginBottom,
      removeBranding: hasRemoveBranding,
    };
    if (selectedTemplate === "template1")  return <WtPrev  temp_type={selectedTemplate} {...commonProps} prefilledmsg={preFilledMsg} />;
    if (selectedTemplate === "template2")  return <WtPrev2 temp_type={selectedTemplate} {...commonProps} prefilledTemplate2={setPreFilledTemplate2} />;
    if (selectedTemplate === "template3")  return <WtPrev3 temp_type={selectedTemplate} {...commonProps} prefilledTemplate3={preFilledTemplate3} />;
    if (selectedTemplate === "template4")  return <WtPrev4 temp_type={selectedTemplate} {...commonProps} prefilledTemplate4={preFilledTemplate4} />;
    if (selectedTemplate === "template5")  return <WtPrev5 temp_type={selectedTemplate} {...commonProps} prefilledTemplate5={preFilledTemplate5} />;
    if (selectedTemplate === "template6")  return <WtPrev6 temp_type={selectedTemplate} {...commonProps} prefilledTemplate6={preFilledTemplate6} />;
    if (selectedTemplate === "template7")  return <WtPrev7 temp_type={selectedTemplate} {...commonProps} prefilledTemplate7={preFilledTemplate7} />;
    if (selectedTemplate === "template8")  return <WtPrev8 temp_type={selectedTemplate} {...commonProps} prefilledTemplate8={preFilledTemplate8} />;
    if (selectedTemplate === "template9")  return <WtPrev9 temp_type={selectedTemplate} {...commonProps} prefilledTemplate9={preFilledTemplate9} />;
    if (selectedTemplate === "template10") return <WtPrev10 temp_type={selectedTemplate} {...commonProps} prefilledTemplate2={setPreFilledTemplate10} />;
    return null;
  };

  return (
    <div>
      {isLoading && <Spining />}

      {showPaymentConfirm && selectedAddonPlan && (
        <div className={styles.modalBackdrop} onClick={() => setShowPaymentConfirm(false)}>
          <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalCloseBtn} onClick={() => setShowPaymentConfirm(false)}>✕</button>

            {/* Header */}
            <div className={styles.modalTopStrip}>
              <div className={styles.modalIconWrap}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#25d366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="5" width="20" height="14" rx="3"/>
                  <path d="M16 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0"/>
                  <path d="M2 10h20"/>
                </svg>
              </div>
              <div className={styles.modalHeaderTitle}>Choose Payment</div>
              <div className={styles.modalHeaderSub}>Complete your purchase securely</div>
            </div>

            <div className={styles.modalBody}>
              {/* Plan summary */}
              <div className={styles.modalPlanRow}>
                <div>
                  <div className={styles.modalPlanName}>{selectedAddonPlan.plan_title}</div>
                  <div className={styles.modalPlanDuration}>Billed {selectedAddonPlan.plan_duration}</div>
                </div>
                <div className={styles.modalPlanPrice}>{currency.symbol}{selectedAddonPlan[currency.key]}</div>
              </div>

              {/* Payment Method */}
              <div className={styles.modalSectionLabel}>Payment Method</div>
              <div className={styles.modalWalletCard}>
                <div className={styles.modalWalletLeft}>
                  <div className={styles.modalWalletIconCircle}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#25d366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 12V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4"/>
                      <circle cx="18" cy="12" r="2"/>
                    </svg>
                  </div>
                  <div>
                    <div className={styles.modalWalletName}>Wallet</div>
                    <div className={styles.modalWalletSub}>Instant deduction from balance</div>
                  </div>
                </div>
                <span className={styles.modalWalletBadge}>✓ Selected</span>
              </div>

              {/* Auto-renew */}
              <div className={styles.modalSectionLabel}>Options</div>
              <div className={styles.modalAutoRenewRow}>
                <div>
                  <div className={styles.modalAutoRenewTitle}>Auto-renew</div>
                  <div className={styles.modalAutoRenewSub}>Automatically renew when plan expires</div>
                </div>
                <label className={styles.modalToggleSwitch}>
                  <input type="checkbox" checked={autoRenew} onChange={(e) => setAutoRenew(e.target.checked)} />
                  <span className={styles.modalToggleSlider}></span>
                </label>
              </div>
            </div>

            <div className={styles.modalFooter}>
              <button className={styles.modalBtnCancel} onClick={() => setShowPaymentConfirm(false)}>Cancel</button>
              <button className={styles.modalBtnConfirm} onClick={() => { setShowPaymentConfirm(false); setShowFinalConfirm(true); }}>Continue →</button>
            </div>
          </div>
        </div>
      )}

      {showFinalConfirm && selectedAddonPlan && (
        <div className={styles.modalBackdrop} onClick={() => !paymentLoading && setShowFinalConfirm(false)}>
          <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            {!paymentLoading && <button className={styles.modalCloseBtn} onClick={() => setShowFinalConfirm(false)}>✕</button>}

            {/* Header */}
            <div className={styles.modalTopStrip}>
              <div className={`${styles.modalIconWrap} ${styles.modalIconWrapBlue}`}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4f46e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  <polyline points="9 12 11 14 15 10"/>
                </svg>
              </div>
              <div className={styles.modalHeaderTitle}>Confirm &amp; Pay</div>
              <div className={styles.modalHeaderSub}>Review your order before payment</div>
            </div>

            <div className={styles.modalBody}>
              {/* Order summary */}
              <div className={styles.modalSectionLabel}>Order Summary</div>
              <div className={styles.modalPlanRow}>
                <div>
                  <div className={styles.modalPlanName}>{selectedAddonPlan.plan_title}</div>
                  <div className={styles.modalPlanDuration}>Billed {selectedAddonPlan.plan_duration}</div>
                </div>
                <div className={styles.modalPlanPrice}>{currency.symbol}{selectedAddonPlan[currency.key]}</div>
              </div>

              {/* Details */}
              <div className={styles.modalDetailsList}>
                <div className={styles.modalDetailRow}>
                  <span className={styles.modalDetailKey}>Plan Duration</span>
                  <span className={styles.modalDetailVal}>{selectedAddonPlan.plan_duration}</span>
                </div>
                <div className={styles.modalDetailRow}>
                  <span className={styles.modalDetailKey}>Payment via</span>
                  <span className={styles.modalDetailVal}>Wallet</span>
                </div>
                <div className={styles.modalDetailRow}>
                  <span className={styles.modalDetailKey}>Auto-renew</span>
                  <span className={`${styles.modalDetailVal} ${autoRenew ? styles.modalDetailValGreen : styles.modalDetailValMuted}`}>
                    {autoRenew ? "Enabled" : "Disabled"}
                  </span>
                </div>
                <div className={`${styles.modalDetailRow} ${styles.modalDetailRowTotal}`}>
                  <span className={styles.modalDetailKey}>Total charged</span>
                  <span className={styles.modalDetailValBold}>{currency.symbol}{selectedAddonPlan[currency.key]}</span>
                </div>
              </div>

              {/* Warning */}
              <div className={styles.modalWarningBox}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                <span>{currency.symbol}{selectedAddonPlan[currency.key]} will be instantly deducted from your wallet. This action cannot be undone.</span>
              </div>
            </div>

            <div className={styles.modalFooter}>
              <button className={styles.modalBtnCancel} onClick={() => { setShowFinalConfirm(false); setShowPaymentConfirm(true); }} disabled={paymentLoading}>← Back</button>
              <button className={styles.modalBtnConfirm} onClick={handlePayment} disabled={paymentLoading}>
                {paymentLoading ? "Processing..." : "Confirm & Pay"}
              </button>
            </div>
          </div>
        </div>
      )}

      {dialogOpen && (
        <Dialog modal={true} title="Response Status" isDraggable={true} onClose={handleCloseDialog} maxWidth={"md"}>
          <div>
            <p>Copy and paste this code into your website's HTML, just before the closing &lt;/body&gt; tag, to ensure proper functionality.</p>
          </div>
          <div>
            <button onClick={handleCopy} className="btn btn-success float-right">
              <FontAwesomeIcon icon={faCopy} /> {copystatus ? "Copied" : "copy"}
            </button>
          </div>
          <div className={`w-100 ${styles.codeBox}`}>
            <p>{responsedata}</p>
          </div>
        </Dialog>
      )}

      <div className="p-2 p-md-3">
        <div className="container-fluid p-0">
          <div className="row mb-2 mb-xl-3 align-items-center">
            <div className="col-auto d-none d-sm-block">
              <Title isButton={false}> Step 2 – WhatsApp Widget </Title>
            </div>
            <div className="col-auto ml-auto">
              <button
                type="button"
                className={showAddons ? styles.addonsBtnActive : styles.addonsBtn}
                onClick={() => setShowAddons((v) => !v)}
              >
                {showAddons ? "← Back" : "✦ Add-ons"}
              </button>
            </div>
            {widgetCreated && (
              <div className="col-auto text-right mt-n1">
                <Link to="/dashboard/whatsapp-widget">
                  <span className="btn btn-primary btn-sm">Create Widget</span>
                </Link>
              </div>
            )}
          </div>

          {alert.successMessage && (
            <div className={alert.bgColor} role="alert">
              <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <div ref={errorDivRef} tabIndex={-1}>{alert.errorMessage}</div>
            </div>
          )}

          {showAddons ? (
            <div className={styles.premiumGrid}>
              {(() => {
                const CARD_THEMES = [
                  { cardClass: styles.premiumCardBlue,  gradient: "linear-gradient(135deg,#4f46e5 0%,#818cf8 100%)", icon: <FiGlobe size={26} color="#fff" />,    accentColor: "#4f46e5", ctaClass: styles.premiumCtaBlue  },
                  { cardClass: styles.premiumCardGreen, gradient: "linear-gradient(135deg,#0891b2 0%,#34d399 100%)", icon: <FiBarChart2 size={26} color="#fff" />, accentColor: "#0891b2", ctaClass: styles.premiumCtaGreen },
                  { cardClass: styles.premiumCardPink,  gradient: "linear-gradient(135deg,#7c3aed 0%,#f472b6 100%)", icon: <FiCpu size={26} color="#fff" />,       accentColor: "#7c3aed", ctaClass: styles.premiumCtaPink  },
                ];
                return addonPlans.map((plan, i) => {
                  const theme = CARD_THEMES[i % CARD_THEMES.length];
                  const lines = plan.plan_description.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
                  const desc = lines[0] || "";
                  const features = lines.slice(1);
                  return (
                    <div key={plan.id} className={`${styles.premiumCard} ${theme.cardClass}`}>
                      <div className={styles.premiumCardHeader} style={{ background: theme.gradient }}>
                        <span className={styles.premiumCardTag}>{plan.plan_title}</span>
                        <div className={styles.premiumCardIconWrap}>{theme.icon}</div>
                      </div>
                      <div className={styles.premiumCardBody}>
                        <div className={styles.premiumCardTitle}>{plan.plan_title}</div>
                        <div className={styles.premiumCardDesc}>{desc}</div>
                        <ul className={styles.premiumFeatures}>
                          {features.map(f => (
                            <li key={f} className={styles.premiumFeature}>
                              <FiCheck size={11} color={theme.accentColor} />{f}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className={styles.premiumCardFooter}>
                        <div>
                          <span className={styles.premiumCardPrice}>{currency.symbol}{plan[currency.key]}</span>
                          <span className={styles.premiumCardPriceSub}>/{plan.plan_duration}</span>
                        </div>
                        {activeAddonNames.has(plan.plan_title)
                          ? <span className={styles.activeBadge}>✓ Active</span>
                          : <button type="button" className={`${styles.premiumCtaBtn} ${theme.ctaClass}`} onClick={() => { setSelectedAddonPlan(plan); setShowPaymentConfirm(true); }}>Add</button>
                        }
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          ) : (
          <div className="row">
            {/* ── Left: Accordion Form ── */}
            <div className="col-12 col-lg-7">

              {(() => {
                const Chevron = ({ open }) => (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                    className={`${styles.chevron} ${open ? styles.chevronOpen : styles.chevronClosed}`}>
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                );

                const commonProps = {
                  mobile_no: whatsappno,
                  wig_name: widgetName,
                  displayname,
                  logourl: logoUrl,
                  bgcolor: wtbgcolor,
                  wltxt: welcomeText,
                  wtstatus: "yes",
                  position,
                  sidemargin: sideMargin,
                  marginbottom: marginBottom,
                  removeBranding: hasRemoveBranding,
                };

                const templates = [
                  { id: "template1",  name: "Chat Button",    comp: <WtPrev  temp_type="template1"  {...commonProps} prefilledmsg={preFilledMsg} /> },
                  { id: "template2",  name: "Text Message",   comp: <WtPrev2 temp_type="template2"  {...commonProps} prefilledTemplate2={preFilledTemplate2} /> },
                  { id: "template3",  name: "Dark Theme",     comp: <WtPrev3 temp_type="template3"  {...commonProps} prefilledTemplate3={preFilledTemplate3} /> },
                  { id: "template4",  name: "Custom Profile", comp: <WtPrev4 temp_type="template4"  {...commonProps} prefilledTemplate4={preFilledTemplate4} /> },
                  { id: "template5",  name: "Shopping",       comp: <WtPrev5 temp_type="template5"  {...commonProps} prefilledTemplate5={preFilledTemplate5} /> },
                  { id: "template6",  name: "Chat Bubble",    comp: <WtPrev6 temp_type="template6"  {...commonProps} prefilledTemplate6={preFilledTemplate6} /> },
                  { id: "template7",  name: "Custom Bubble",  comp: <WtPrev7 temp_type="template7"  {...commonProps} prefilledTemplate7={preFilledTemplate7} /> },
                  { id: "template8",  name: "Hospital",       comp: <WtPrev8 temp_type="template8"  {...commonProps} prefilledTemplate8={preFilledTemplate8} /> },
                  { id: "template9",  name: "Support",        comp: <WtPrev9 temp_type="template9"  {...commonProps} prefilledTemplate9={preFilledTemplate9} /> },
                  { id: "template10", name: "Pill Button",    comp: <WtPrev10 temp_type="template10" {...commonProps} prefilledTemplate2={preFilledTemplate10} /> },
                ];

                return (
                  <>
                    {/* Select Template */}
                    <div className={`${styles.cardWrap} ${openSections.step_template ? styles.cardWrapOpen : styles.cardWrapClosed}`}>
                      <div className={`${styles.headerWrap} ${openSections.step_template ? styles.headerWrapOpen : styles.headerWrapClosed}`} onClick={() => toggleSection("step_template")}>
                        <div className="d-flex align-items-center">
                          <span className={`${styles.stepBadge} ${openSections.step_template ? styles.stepBadgeOpen : styles.stepBadgeClosed}`}><FiLayout size={15} /></span>
                          <div>
                            <div className={styles.stepTitle}>Select Template</div>
                            <div className={styles.stepSubtitle}>
                              {selectedTemplate
                                ? `Selected: ${templates.find(t => t.id === selectedTemplate)?.name || selectedTemplate}`
                                : "Choose a widget layout"}
                            </div>
                          </div>
                        </div>
                        <Chevron open={openSections.step_template} />
                      </div>
                      {openSections.step_template && (
                        <div className={styles.sectionBody}>
                          <div className={styles.templateScrollBox}>
                            <div className={styles.templateGrid}>
                              {templates.map((t) => {
                                const isSelected = selectedTemplate === t.id;
                                return (
                                  <div
                                    key={t.id}
                                    onClick={() => setSelectedTemplate(t.id)}
                                    className={`${styles.templateCard} ${isSelected ? styles.templateCardSelected : styles.templateCardUnselected}`}
                                  >
                                    {isSelected && (
                                      <span className={styles.templateCheckmark}>✓</span>
                                    )}
                                    <div className={styles.templatePreview}>
                                      <div className={styles.templateScaleWrap}>
                                        {t.comp}
                                      </div>
                                    </div>
                                    <div className={styles.templateFooter}>
                                      <div className={`${styles.templateName} ${isSelected ? styles.templateNameSelected : styles.templateNameUnselected}`}>{t.name}</div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Widget Identity, Appearance, Position & Behaviour */}
                    <div className={`${styles.cardWrap} ${openSections.step_settings ? styles.cardWrapOpen : styles.cardWrapClosed}`}>
                      <div className={`${styles.headerWrap} ${openSections.step_settings ? styles.headerWrapOpen : styles.headerWrapClosed}`} onClick={() => toggleSection("step_settings")}>
                        <div className="d-flex align-items-center">
                          <span className={`${styles.stepBadge} ${openSections.step_settings ? styles.stepBadgeOpen : styles.stepBadgeClosed}`}><FiSettings size={15} /></span>
                          <div>
                            <div className={styles.stepTitle}>Identity, Appearance &amp; Position</div>
                            <div className={styles.stepSubtitle}>Profile, colors, greetings and placement</div>
                          </div>
                        </div>
                        <Chevron open={openSections.step_settings} />
                      </div>
                      {openSections.step_settings && (
                        <div className={styles.sectionBodyMd}>

                          {/* Widget Identity */}
                          <div className="row">
                            <div className="col-sm-6 mb-3">
                              <label className={styles.fieldLabel}>WhatsApp No. <span className="text-danger">*</span></label>
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className={`input-group-text ${styles.waPrefix}`}>WA</span>
                                </div>
                                <input type="tel" inputMode="numeric" className={`form-control ${styles.inputControl}`} style={{ borderLeft: "none" }} placeholder="Enter WhatsApp No." value={whatsappno} disabled onChange={(e) => setWhatsappno(e.target.value.replace(/\D/g, ""))} />
                              </div>
                              <small className={styles.smallHint}>Include country code, e.g. +91 98765 43219</small>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <label className={styles.fieldLabel}>Display Name <span className="text-danger">*</span></label>
                              <input type="text" className={`form-control ${styles.inputControl}`} placeholder="Enter Display Name" value={displayname} onChange={(e) => setDisplayname(e.target.value)} />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 mb-3">
                              <label className={styles.fieldLabel}>Widget Name <span className="text-danger">*</span></label>
                              <input type="text" className={`form-control ${styles.inputControl}`} placeholder="Enter Widget Name" value={widgetName} onChange={(e) => setWidgetName(e.target.value)} />
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className={styles.fieldLabel}>Logo Upload</label>
                            <div
                              onClick={() => document.getElementById("logo-upload-input").click()}
                              className={styles.dropZone}
                              style={logoFile ? { borderColor: "#25D366", background: "#f0fdf4" } : {}}
                            >
                              {logoFile ? (
                                <>
                                  <img src={logoUrl} alt="logo preview" style={{ width: 56, height: 56, borderRadius: 8, objectFit: "cover", border: "2px solid #25D366" }} />
                                  <div className={styles.dropZoneText} style={{ marginTop: 8 }}>
                                    <span style={{ color: "#16a34a", fontWeight: 600 }}>✓ {logoFile.name}</span>
                                  </div>
                                  <div className={styles.dropZoneHint}><span className={styles.dropZoneBrowse}>Click to change</span></div>
                                </>
                              ) : (
                                <>
                                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.8">
                                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                                  </svg>
                                  <div className={styles.dropZoneText}>Drag &amp; drop logo file, or <span className={styles.dropZoneBrowse}>browse</span></div>
                                  <div className={styles.dropZoneHint}>1:1 ratio · max 50KB · PNG, JPG</div>
                                </>
                              )}
                              <input type="file" id="logo-upload-input" style={{ display: "none" }} onChange={handleLogoChange} accept="image/*" />
                            </div>
                          </div>

                          {/* Appearance */}
                          <div className="row mb-3">
                            <div className="col-sm-6 mb-3">
                              <label className={styles.fieldLabel}>Background Color</label>
                              <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                <input type="color" value={wtbgcolor} onChange={(e) => setWtbgcolor(e.target.value)} className={styles.colorInput} />
                                <span className={styles.colorHex}>{wtbgcolor.toUpperCase()}</span>
                              </div>
                              <div className={`d-flex mt-2 ${styles.colorSwatchRow}`}>
                                {["#128C7E","#25D366","#075E54","#34B7F1","#6c5ce7","#2d3436","#000000"].map((c) => (
                                  <div key={c} onClick={() => setWtbgcolor(c)} title={c}
                                    className={`${styles.colorSwatch} ${wtbgcolor === c ? styles.colorSwatchSelected : styles.colorSwatchUnselected}`}
                                    style={{ background: c }}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className={styles.fieldLabel}>Welcome text <span className="text-danger">*</span></label>
                            <textarea className={`form-control ${styles.inputControl} ${styles.inputControlTextarea}`} rows="3" placeholder="Hi there 👋, How can I help you?" value={welcomeText} onChange={(e) => setWelcomeText(e.target.value)} maxLength={94} />
                          </div>
                          {selectedTemplate === "template1" && (
                            <div className="mb-3">
                              <label className={styles.fieldLabel}>Pre-filled message</label>
                              <textarea className={`form-control ${styles.inputControl} ${styles.inputControlTextarea}`} rows="2" placeholder="Enter pre-filled message" value={preFilledMsg} onChange={(e) => setPreFilledMsg(e.target.value)} maxLength={94} />
                            </div>
                          )}

                          {/* Position & Behaviour */}
                          <div className="row mb-4">
                            <div className="col-sm-5 mb-3">
                              <label className={styles.fieldLabel}>Open widget by default?</label>
                              <div className="d-flex" style={{ gap: 8 }}>
                                {["no","yes"].map((val) => (
                                  <button key={val} type="button" onClick={() => setWidgetStatus(val)}
                                    className={`${styles.statusBtn} ${widgetStatus === val ? styles.statusBtnActive : styles.statusBtnInactive}`}>
                                    {val.charAt(0).toUpperCase() + val.slice(1)}
                                  </button>
                                ))}
                              </div>
                            </div>
                            <div className="col-sm-7 mb-3">
                              <label className={styles.fieldLabel}>Widget Position</label>
                              <div className="d-flex" style={{ gap: 10 }}>
                                {[{val:"left",label:"Left Side",sub:"Left-aligned"},{val:"right",label:"Right Side",sub:"Right-aligned"}].map(({val,label,sub}) => (
                                  <div key={val} onClick={() => setPosition(val)}
                                    className={`${styles.positionCard} ${position === val ? styles.positionCardSelected : styles.positionCardUnselected}`}>
                                    <div className={`${styles.positionLabel} ${position === val ? styles.positionLabelSelected : styles.positionLabelUnselected}`}>{label}</div>
                                    <div className={`${styles.positionSub} ${position === val ? styles.positionSubSelected : styles.positionSubUnselected}`}>{sub}</div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="d-flex justify-content-between mb-1">
                              <label className={styles.fieldLabel}>Margin Bottom</label>
                              <span className={styles.rangeLabel}>{marginBottom}px</span>
                            </div>
                            <input type="range" className="form-range w-100" min="0" max="300" value={marginBottom} onChange={(e) => setMarginBottom(e.target.value)} />
                            <div className="d-flex justify-content-between"><small className={styles.rangeHint}>0px</small><small className={styles.rangeHint}>300px</small></div>
                          </div>
                          <div className="mb-2">
                            <div className="d-flex justify-content-between mb-1">
                              <label className={styles.fieldLabel}>Margin Right</label>
                              <span className={styles.rangeLabel}>{sideMargin}px</span>
                            </div>
                            <input type="range" className="form-range w-100" min="0" max="300" value={sideMargin} onChange={(e) => setSideMargin(e.target.value)} />
                            <div className="d-flex justify-content-between"><small className={styles.rangeHint}>0px</small><small className={styles.rangeHint}>300px</small></div>
                          </div>

                        </div>
                      )}
                    </div>

                    {/* Create Widget Button */}
                    <div className="d-flex justify-content-end mb-4">
                      <button type="button" onClick={handleForm} disabled={disable} className={styles.createBtn}>
                        + Create Widget
                      </button>
                    </div>
                  </>
                );
              })()}
            </div>

            {/* ── Right: Live Preview ── */}
            <div className={`col-lg-5 d-none d-lg-block pt-0 ${styles.previewPanel}`}>

              <div className={styles.previewContainer}>
                {/* fake browser chrome */}
                <div className={styles.browserChrome}>
                  <span className={`${styles.dot} ${styles.dotRed}`} />
                  <span className={`${styles.dot} ${styles.dotYellow}`} />
                  <span className={`${styles.dot} ${styles.dotGreen}`} />
                  <div className={styles.addressBar}>your-website.com</div>
                </div>
                {/* scaled widget */}
                <div className={styles.previewBody}>
                  <div className={styles.previewScaleWrap}>
                    {renderPreview()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default WhatsappWidget;
